import { useMutation } from '@tanstack/react-query';
import { deleteBehaviorRequest } from '../requests/deleteBehaviorRequest';
import { queryClient } from '../../../app/App';
import { Alert } from '../../../components/Alert';
import { AxiosError } from 'axios';

export function useDeleteBehavior() {
	const deleteBehavior = useMutation({
		mutationFn: async (id: number) => {
			return deleteBehaviorRequest(id);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully deleted!', type: 'success' });
			queryClient.invalidateQueries(['BEHAVIOR_LIST']);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return {
		deleteBehavior,
	};
}
